import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddUtiltyComponent } from './add-utilty/add-utilty.component';
import { AllUtiltesComponent } from './all-utiltes/all-utiltes.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddSectionComponent } from './add-section/add-section.component';
import { AddInoviceComponent } from './add-inovice/add-inovice.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    AddUtiltyComponent,
    AllUtiltesComponent,
    AddSectionComponent,
    AddInoviceComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule
  ]
})
export class UtiltyModule { }
